import * as utils from '@utils/form';
import { RELATED_CONTENT_TYPE } from '@constants/relatedContentModules';
import { TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  COPYRIGHT: {
    name: 'copyright',
    label: 'Copyright:',
    rules: [{ max: 300, message: 'The copyright should be less than 300 chars' }],
  },
  RELATED_ATHLETES: {
    name: 'relatedAthlete',
    type: RELATED_CONTENT_TYPE.ATHLETES,
    serialize: utils.relatedContentSerializer,
  },
  RELATED_DISCIPLINES: {
    name: 'relatedDiscipline',
    type: RELATED_CONTENT_TYPE.DISCIPLINES,
    serialize: utils.relatedContentSerializer,
  },
  RELATED_COMPETITIONS: {
    name: 'relatedCompetition',
    type: RELATED_CONTENT_TYPE.COMPETITIONS,
    serialize: utils.relatedContentSerializer,
  },
  // RELATED_ARTICLES: {
  //   name: 'relatedArticle',
  //   type: RELATED_CONTENT_TYPE.ARTICLES,
  //   serialize: utils.relatedContentSerializer,
  // },
  RELATED_EVENTS: {
    name: 'relatedEvent',
    type: RELATED_CONTENT_TYPE.EVENTS,
    serialize: utils.relatedContentSerializer,
  },
  // RELATED_URLS: {
  //   name: 'relatedUrls',
  //   type: RELATED_CONTENT_TYPE.URLS,
  // },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
